const mockData = [
  {
    id: 1,
    album: 'Doomicus Epicus Metallicus',
    artist: 'Candlemass',
    released: '1986',
    genre: 'Metal'
  },
  {
    id: 2,
    album: 'Paranoid',
    artist: 'Black Sabbath',
    released: '1970',
    genre: 'Metal'
  },
  {
    id: 3,
    album: 'Led Zeppelin I',
    artist: 'Led Zeppelin',
    released: '1969',
    genre: 'Classic Rock'
  },
  {
    id: 4, 
    album: 'The Dark Side Of The Moon',
    artist: 'Pink Floyd',
    released: '1973',
    genre: 'Classic Rock'
  },
  {
    id: 5,
    album: 'Painkiller',
    artist: 'Judas Priest',
    released: '1990',
    genre: 'Metal'
  },
  {
    id: 6,
    album: 'DAMN.',
    artist: 'Kendrick Lamar',
    released: '2017',
    genre: 'Hip Hop'
  }
]

export default mockData